var _g, _g2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferFriendIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2713_65600",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 8,
    height: 8
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2713_65600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.76 3.88734V1.86562L12.6989 2.90328L12.2349 2.45094C12.9136 1.7719 13.353 1.3267 14.039 0.640625C14.7002 1.30174 15.2048 1.80934 15.8464 2.45094L15.4157 2.90328L14.4 1.86562V3.88734C14.4 5.6547 12.9674 7.08734 11.2 7.08734C9.43264 7.08734 8 5.6547 8 3.88734V0.687344H8.64V3.88734C8.64 5.3011 9.78624 6.44734 11.2 6.44734C12.6138 6.44734 13.76 5.3011 13.76 3.88734Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2713_65600)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.418,
    y: 1.30859,
    width: 10.9347,
    height: 12.3636,
    transform: "rotate(-12.3058 10.418 1.30859)",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46641 7.46641C6.05457 7.46641 4.90641 6.31825 4.90641 4.90641C4.90641 3.49457 6.05457 2.34641 7.46641 2.34641C8.87825 2.34641 10.0264 3.49457 10.0264 4.90641C10.0264 6.31825 8.87825 7.46641 7.46641 7.46641ZM9.87152 7.89711C10.7458 7.19375 11.3064 6.11601 11.3064 4.90641C11.3064 2.78545 9.58737 1.06641 7.46641 1.06641C5.34545 1.06641 3.62641 2.78545 3.62641 4.90641C3.62641 6.11601 4.18705 7.19375 5.06129 7.89711C2.71953 8.77711 1.06641 10.9512 1.06641 13.8664H2.34641C2.34641 10.6664 4.64337 8.74641 7.46641 8.74641C10.2894 8.74641 12.5864 10.6664 12.5864 13.8664H13.8664C13.8664 10.9512 12.2133 8.77711 9.87152 7.89711Z",
    fill: "#F9F9F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2713_65600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferFriendIconSvg);
export default __webpack_public_path__ + "static/media/referFriend-icon-svg.b81f5771519001e046fe541ffd235663.svg";
export { ForwardRef as ReactComponent };